<template>
  <b-card
    v-if="pengumuman"
    class="pengumuman-detail-card"
  >
    <div class="text-center mb-2">
      <h1 class="mb-1">
        {{ pengumuman.judul }}
      </h1>
      <b-card-text class="text-muted">
        Diposting pada: {{ pengumuman.tanggal }}
      </b-card-text>
    </div>

    <!-- Image -->
    <div
      v-if="foto"
      class="text-center mb-3"
    >
      <b-img
        :src="foto"
        fluid
        rounded
        class="announcement-image"
      />
    </div>

    <!-- Content -->
    <div
      class="pengumuman-content px-md-5"
      v-html="pengumuman.pengumuman"
    />

    <!-- External Link -->
    <div
      v-if="pengumuman.link"
      class="text-center mt-3"
    >
      <b-button
        variant="outline-primary"
        :href="pengumuman.link"
        target="_blank"
      >
        Link Terkait
      </b-button>
    </div>

    <!-- Back Button -->
    <div class="text-center mt-4">
      <b-button
        variant="flat-secondary"
        to="/pages/pengumuman"
      >
        <feather-icon
          icon="ArrowLeftIcon"
          class="mr-50"
        />
        Kembali ke Daftar Pengumuman
      </b-button>
    </div>
  </b-card>
</template>

<script>
import {
  BCard, BImg, BCardText, BButton, BRow, BCol,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { getPengumumanDetail } from '@/connection-api/pengumuman'
import { downloadPhoto } from '@/connection-api/lembarkehidupan'

export default {
  components: {
    BCard,
    BButton,
    BCardText,
    BImg,
    BRow,
    BCol,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      pengumuman: null,
      foto: null,
    }
  },
  async mounted() {
    const { uuid } = this.$route.params
    try {
      const response = await getPengumumanDetail(uuid)
      if (response.data && response.data.status.code === '00') {
        this.pengumuman = response.data.data
        if (this.pengumuman.gambar) {
          this.getPhoto(this.pengumuman.gambar)
        }
      }
    } catch (error) {
      console.error('Error fetching pengumuman detail:', error)
    }
  },
  methods: {
    async getPhoto(filename) {
      const params = { filename }
      try {
        const responsePhoto = await downloadPhoto(params)
        if (responsePhoto.data && responsePhoto.data.status.code === '00') {
          this.foto = responsePhoto.data.data.img_base64
        }
      } catch (error) {
        console.error('Error downloading photo:', error)
      }
    },
  },
}
</script>

<style lang="scss">
.pengumuman-detail-card {
  max-width: 1000px;
  margin: 2rem auto;
}

.announcement-image {
  max-height: 500px;
  object-fit: contain;
}

.pengumuman-content {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #333;

  /* Ensure Quill styling is preserved or looks good */
  p {
    margin-bottom: 1.5rem;
  }

  img {
    max-width: 1000px;
    height: auto;
  }
}
</style>
